import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/tree',
      name: '/tree',
      component: resolve => require(['@/components/MyTree'], resolve),
      meta: {
        title: '列表'
      }
    },
    {
      path: '/sixam',
      name: '/sixam',
      component: resolve => require(['@/components/sixam'], resolve),
      meta: {
        title: '澳门'
      }
    },
    {
      path: '/',
      name: '/index',
      component: resolve => require(['@/components/index'], resolve),
      meta: {
        title: '首页'
      }
    },
    {
      path: '/manga',
      name: '/manga',
      component: resolve => require(['@/components/manga'], resolve),
      meta: {
        title: '漫画清单'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js